import {Field} from 'formik';
import {Container} from "@mantine/core";
import {SubscriptionsAutocomplete} from "../../customer-subscriptions/inputs/SubscriptionsAutocomplete.tsx";
import {PlatformFieldset} from "@flexinet/ui-components";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <Container>
            <PlatformFieldset legend={'Order'}>
                <Field
                    name='customerId'
                    label='Customer'
                    description='Please enter the customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='subscriptionId'
                    label='Subscription'
                    description='Please enter order subscription'
                    component={SubscriptionsAutocomplete}
                    my={'xl'}
                />

            </PlatformFieldset>

        </Container>
    );
};
